import type { ReactElement } from "react";
import { Link } from "@tanstack/react-router";

export function MarketingFooter(): ReactElement {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#dfe7e4]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-5 py-10 text-xs text-[#65736f] sm:flex-row sm:px-8">
        <div className="flex items-center gap-2">
          <span className="font-semibold tracking-[-0.03em] text-[#263934]">
            chill
          </span>
          <span>© {year}</span>
        </div>
        <div className="flex items-center gap-7">
          <Link
            to="/legal/$doc"
            params={{ doc: "privacy" }}
            className="transition-colors hover:text-foreground"
          >
            Privacy
          </Link>
          <Link
            to="/legal/$doc"
            params={{ doc: "terms" }}
            className="transition-colors hover:text-foreground"
          >
            Terms
          </Link>
          <a
            href="mailto:hello@getchill.ai"
            className="transition-colors hover:text-foreground"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
